import { render, staticRenderFns } from "./PremiumActionModal.vue?vue&type=template&id=ab71d780&scoped=true"
import script from "./PremiumActionModal.vue?vue&type=script&lang=js"
export * from "./PremiumActionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab71d780",
  null
  
)

export default component.exports